export enum JWTSupportedServices {
    PINATA = "pinata",
}
